var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: _vm.getTitulo,
        modalNova: true,
        width: 500
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "validation-observer",
              { ref: "observer" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required|min_painel:2" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: { label: "Nome do painel: ", required: true }
                          }),
                          _c("el-input", {
                            staticClass: "input width-50",
                            class: { erro: errors.length },
                            attrs: { maxlength: 50 },
                            model: {
                              value: _vm.painel.nome,
                              callback: function($$v) {
                                _vm.$set(_vm.painel, "nome", $$v)
                              },
                              expression: "painel.nome"
                            }
                          }),
                          _c("br"),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ]),
                          _c("br")
                        ]
                      }
                    }
                  ])
                }),
                _c("app-label", {
                  attrs: { label: "Descrição:", required: false }
                }),
                _c("el-input", {
                  staticClass: "input width-50",
                  attrs: { type: "textarea" },
                  model: {
                    value: _vm.painel.descricao,
                    callback: function($$v) {
                      _vm.$set(_vm.painel, "descricao", $$v)
                    },
                    expression: "painel.descricao"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                key: "botao-confirma",
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.criarPainel()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.getLabel))]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56e5fa4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e5fa4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/ModalCadastroPainel.vue
// module id = null
// module chunks = 